import Vue from "vue";
import App from "./App.vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
// import i18n from "./i18n/i18n.js"; // 引入 i18n 配置
import axios from "./utils/axios"; // 引入自定义的 axios 配置
import router from "./router"; // 引入路由配置
import "./assets/css/index.scss";
import component from "./components";
import store from './store';
for (const key in component) {
  Vue.component(key, component[key]);
}

Vue.use(Antd);
Vue.prototype.$axios = axios; // 将 axios 挂载到 Vue 原型上

new Vue({
  router,
  store,
  // i18n,
  render: (h) => h(App),
}).$mount("#app");
